// Temas visuales de SOFI 2.0 (HSL). El cliente eligió "Océano" como predeterminado.
export const THEMES = [
  {
    id: "oceano", name: "Océano", desc: "Azul océano / teal. Sereno y de confianza.",
    headingFont: '"Figtree", system-ui, sans-serif',
    light: {
      "--background": "36 33% 98%", "--card": "0 0% 100%",
      "--secondary": "200 30% 96%", "--muted": "200 30% 96%",
      "--border": "214 18% 88%", "--input": "214 18% 88%",
      "--primary": "196 78% 34%", "--primary-foreground": "0 0% 100%",
      "--accent": "174 45% 92%", "--accent-foreground": "196 78% 22%",
      "--ring": "196 78% 34%",
      "--chart-1": "196 78% 34%", "--chart-2": "174 50% 40%", "--chart-3": "206 88% 45%", "--chart-4": "38 92% 50%", "--chart-5": "152 55% 34%",
    },
    dark: {
      "--background": "222 22% 10%", "--card": "222 22% 12%",
      "--secondary": "222 18% 16%", "--muted": "222 18% 16%",
      "--border": "222 16% 20%", "--input": "222 16% 20%",
      "--primary": "196 78% 48%", "--primary-foreground": "222 22% 10%",
      "--accent": "196 40% 18%", "--accent-foreground": "190 70% 80%",
      "--ring": "196 78% 48%",
      "--chart-1": "196 78% 56%", "--chart-2": "174 55% 55%", "--chart-3": "206 88% 64%", "--chart-4": "38 92% 60%", "--chart-5": "152 50% 52%",
    },
  },
  {
    id: "bosque", name: "Bosque", desc: "Verde esmeralda. Natural y amable.",
    headingFont: '"Montserrat", system-ui, sans-serif',
    light: {
      "--background": "90 25% 98%", "--card": "0 0% 100%",
      "--secondary": "150 25% 95%", "--muted": "150 25% 95%",
      "--border": "150 18% 86%", "--input": "150 18% 86%",
      "--primary": "158 64% 30%", "--primary-foreground": "0 0% 100%",
      "--accent": "152 45% 90%", "--accent-foreground": "158 64% 22%",
      "--ring": "158 64% 30%",
      "--chart-1": "158 64% 32%", "--chart-2": "174 50% 40%", "--chart-3": "130 45% 42%", "--chart-4": "38 92% 50%", "--chart-5": "200 70% 42%",
    },
    dark: {
      "--background": "165 22% 9%", "--card": "165 18% 12%",
      "--secondary": "165 14% 16%", "--muted": "165 14% 16%",
      "--border": "165 12% 20%", "--input": "165 12% 20%",
      "--primary": "156 64% 44%", "--primary-foreground": "165 22% 9%",
      "--accent": "160 35% 17%", "--accent-foreground": "150 60% 80%",
      "--ring": "156 64% 44%",
      "--chart-1": "156 60% 50%", "--chart-2": "174 55% 55%", "--chart-3": "130 45% 55%", "--chart-4": "38 92% 60%", "--chart-5": "200 70% 58%",
    },
  },
  {
    id: "coral", name: "Coral", desc: "Coral cálido sobre arena.",
    headingFont: '"Fredoka", system-ui, sans-serif',
    light: {
      "--background": "28 50% 98%", "--card": "0 0% 100%",
      "--secondary": "24 50% 95%", "--muted": "24 40% 95%",
      "--border": "24 30% 88%", "--input": "24 30% 88%",
      "--primary": "14 78% 48%", "--primary-foreground": "0 0% 100%",
      "--accent": "24 85% 92%", "--accent-foreground": "14 70% 32%",
      "--ring": "14 78% 48%",
      "--chart-1": "14 78% 52%", "--chart-2": "32 90% 52%", "--chart-3": "174 45% 42%", "--chart-4": "348 70% 58%", "--chart-5": "40 90% 48%",
    },
    dark: {
      "--background": "18 24% 10%", "--card": "18 20% 13%",
      "--secondary": "18 16% 17%", "--muted": "18 16% 17%",
      "--border": "18 14% 22%", "--input": "18 14% 22%",
      "--primary": "14 85% 58%", "--primary-foreground": "18 24% 10%",
      "--accent": "14 40% 18%", "--accent-foreground": "22 85% 80%",
      "--ring": "14 85% 58%",
      "--chart-1": "14 85% 62%", "--chart-2": "32 90% 60%", "--chart-3": "174 50% 52%", "--chart-4": "348 70% 64%", "--chart-5": "40 90% 56%",
    },
  },
  {
    id: "indigo", name: "Índigo", desc: "Índigo sobrio. Elegante.",
    headingFont: '"Playfair Display", Georgia, serif',
    light: {
      "--background": "225 30% 98%", "--card": "0 0% 100%",
      "--secondary": "226 35% 95%", "--muted": "226 30% 95%",
      "--border": "224 25% 88%", "--input": "224 25% 88%",
      "--primary": "232 58% 50%", "--primary-foreground": "0 0% 100%",
      "--accent": "230 60% 94%", "--accent-foreground": "232 58% 36%",
      "--ring": "232 58% 50%",
      "--chart-1": "232 58% 52%", "--chart-2": "200 80% 46%", "--chart-3": "190 70% 44%", "--chart-4": "38 92% 52%", "--chart-5": "160 55% 40%",
    },
    dark: {
      "--background": "230 24% 10%", "--card": "230 22% 13%",
      "--secondary": "230 18% 17%", "--muted": "230 18% 17%",
      "--border": "230 16% 22%", "--input": "230 16% 22%",
      "--primary": "230 72% 66%", "--primary-foreground": "230 24% 10%",
      "--accent": "232 35% 20%", "--accent-foreground": "225 70% 84%",
      "--ring": "230 72% 66%",
      "--chart-1": "230 72% 68%", "--chart-2": "200 80% 60%", "--chart-3": "190 70% 58%", "--chart-4": "38 92% 62%", "--chart-5": "160 55% 54%",
    },
  },
];

export const applyTheme = (themeId, dark) => {
  const t = THEMES.find((x) => x.id === themeId) || THEMES[0];
  const el = document.documentElement;
  const vars = dark ? t.dark : t.light;
  Object.entries(vars).forEach(([k, v]) => el.style.setProperty(k, v));
  el.style.setProperty("--font-heading", t.headingFont);
};
